import Button from '@cobliteam/colib-ui/Button';
import Typography from '@cobliteam/ui/components/Typography';
import type { ReactNode } from 'react';
import { NUDGE_SURFACE } from './nudgeSurface';

export interface NudgeMessageProps {
  title: ReactNode;
  description: ReactNode;
  /** Omit both to render a body with no primary action — loading and empty states. */
  ctaLabel?: string;
  onCta?: () => void;
  dismissLabel?: string;
  onDismiss?: () => void;
}

/**
 * The standard nudge body: title, description and up to two actions. A source only reaches for
 * this when it has nothing bespoke to render (the Cobli Conecta slide, for instance, brings its
 * own QR dialog and skips it).
 */
const NudgeMessage = ({ title, description, ctaLabel, onCta, dismissLabel, onDismiss }: NudgeMessageProps) => (
  <div className='flex w-full flex-col gap-[9px]'>
    <Typography variant='description-title' className={NUDGE_SURFACE.title}>
      {title}
    </Typography>

    <Typography variant='description-list-default' className={`text-start ${NUDGE_SURFACE.muted}`}>
      {description}
    </Typography>

    <div className='flex flex-wrap items-center justify-between gap-4 pt-1'>
      {dismissLabel && onDismiss ? (
        <Button variant='ghost' size='sm' onClick={onDismiss}>
          {dismissLabel}
        </Button>
      ) : (
        <span />
      )}
      {ctaLabel && onCta && (
        <Button size='sm' onClick={onCta}>
          {ctaLabel}
        </Button>
      )}
    </div>
  </div>
);

export default NudgeMessage;
